import { Enums } from "../../common/helper/enums";
import type { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import vuexStore from "../store/store";
import { UrlHelper } from "../../common/helper/url-helper-service";
import { authService } from "../../common/services/auth-service";
import { CxAppSettingsService } from "../../common/services/cx-app-settings-service";
import { DataBootstrapper } from "../../infrastructure/data-bootstrappper";
import CustomEventEmitter from "../../common/helper/event-emitter";
import {
  moduleRegistry,
  routesWithFilters,
} from "@/router/preset-route-config";
import { ServiceProviderSignUp } from "@/common/model/serviceprovider/service-provider-model";
import { shouldSkipGetMspCxSetting } from "@/common/helper/public-function-access";
import axios from "axios";
import { constants } from "@/common/constant/constants";

export default class PresetLoader {
  routes: any;
  me: any;

  //public jobCompleted: (ability: any, router: any) => void;
  public jobCompleted: (themeId: number) => void = () => {};

  /** Loads MSP CX branding (GetMspCXSetting) before / while the login screen is shown. */
  async initUnauthenticated(store: any): Promise<void> {
    try {
      if (!UrlHelper.isPublicURL()) {
        await this.fetchAndApplyMspCxSettings();
      } else {
        await CxAppSettingsService.loadFavIconAndTitle();
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      store.commit("MasterModule/SET_LOGIN_BRANDING_LOADING", false);
    }

    if (!UrlHelper.isPublicURL() && !UrlHelper.isAuthVerificationURL()) {
      UrlHelper.redirectToSignIn();
    }
  }

  private async fetchAndApplyMspCxSettings(): Promise<void> {
    if (shouldSkipGetMspCxSetting()) {
      await CxAppSettingsService.loadDefaultSettings();
      return;
    }

    const model = new ServiceProviderSignUp.GetCXBrandingInfo(
      window.location.hostname,
    );
    const mspCxSettings = await axios.post(
      constants.apiUrl.CommonUrls.getMspCXSetting,
      model,
    );
    await CxAppSettingsService.applyMspCxSettings(mspCxSettings?.data);
  }

  async Init(store: any) {
    if (!authService.isAuthenticated()) {
      await this.initUnauthenticated(store);
      this.jobCompleted(1);
      return;
    }

    await DataBootstrapper.loadBootData();
    let contact = store.getters["ContactModule/getContact"];
    this.jobCompleted(contact.themeId);
    //let contact = Vue.prototype.$store.getters["ContactModule/getContact"];
    CustomEventEmitter.getInstance().emit("bootApp", contact.themeId);
  }

  //#endregion
  initialChecker(arg: any) {
    arg.jobCompleted();
  }

  navigationGuard(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) {
    //If user was on a public url, and is now navigating to app's non-public route, redirecting the user to login screen
    if (
      from.fullPath.includes("/public/") &&
      to.fullPath.includes("/public/")
    ) {
      UrlHelper.redirectToSignIn();
    }

    //updating intercom
    try {
      vuexStore.dispatch("updateIntercom");
    } catch (e) {
      console.error(e);
    }

    if (
      vuexStore != null &&
      vuexStore.getters.getApplicationType ==
        Enums.ApplicationType.TicketDetailPopout
    ) {
      if (to.name == "ticket-detail") {
        next({
          path: "/ticket/ticket-detail/" + to.params.ticketId + "/popout",
        });
      }

      //Preventing route change if user is on Ticket Detail popout to any other page
      else if (
        from.name == "ticket-detail-popout" &&
        to.name != "ticket-detail-popout"
      ) {
        return;
      }
    }

    //save previous route for admin-setting
    if (to.name == "admin-settings") {
      let prevRouteObj = {
        name: from.name,
        params: from.params,
      };
      vuexStore.dispatch(
        "technicianStoreModule/savePreviousRouteObject",
        prevRouteObj,
      );
    }

    vuexStore.dispatch("filterStateModule/routeCheckFilter", to.name);

    // Show/Hide right side bar before changing route
    if (
      to.name &&
      (routesWithFilters as readonly string[]).includes(to.name.toString())
    ) {
      vuexStore.dispatch("MasterModule/ShowHamBurger");
    } else {
      vuexStore.dispatch("MasterModule/HideHamBurger");
    }
    if (
      vuexStore.getters.getDesktopStatus ||
      vuexStore.getters.getLargeDesktopStatus ||
      vuexStore.getters.getTabletLandscapeStatus
    ) {
      vuexStore.dispatch("MasterModule/ShowRightSideBarToggle");
    } else {
      vuexStore.dispatch("MasterModule/HideRightSideBarToggle");
    }

    if (vuexStore.getters.getTechnician.isResetPasswordOccurred) {
      next();
    } else {
      const routeNameLower = to.name!.toString().toLocaleLowerCase();
      const resetPasswordIdx = routeNameLower.indexOf("reset-password");
      if (resetPasswordIdx == -1) {
        next({ path: "/application/reset-password" });
      } else {
        next();
      }
    }

    //Focusing on body to allow hotkeys to work as soon as user navigates to a page
    setTimeout(() => {
      if (document.activeElement) {
        (document.activeElement as HTMLElement).blur();
      }
      window.focus();
      document.body.focus();
    }, 1000);
  }

  getRouteFromStorage(store: any) {
    const routes = store.state.routes;
    if (routes) {
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].filename) {
          this.GetModuleBasedRoute(routes[i]);
        }
      }
    }
  }

  private GetModuleBasedRoute(_route: any) {
    const fileExt = ".vue";
    const menuModule = _route.path.split("/")[1];
    const filename = _route.filename;

    const registry = moduleRegistry[menuModule];

    if (!registry) {
      _route.component = () =>
        import("../../common/components/error-component.vue");
      return;
    }

    const key = Object.keys(registry).find((path) =>
      path.endsWith(`/${filename}${fileExt}`),
    );

    const loader = key ? registry[key] : null;

    _route.component =
      loader || (() => import("../../common/components/error-component.vue"));
  }
}
